var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass:
        "\n    fill-height\n    max-width\n    pa-0\n    d-flex\n    flex-row flex-grow-1\n    justify-end\n    align-end\n  ",
      attrs: { fluid: "" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "\n      max-width\n      text-start text-block text-truncate\n      pl-2\n      d-flex\n      flex-column\n      align-items-end\n    ",
        },
        [
          _c(
            "div",
            {
              class:
                _vm.year.indexOf("-") != -1 ? "text-caption" : "text-caption",
            },
            [_vm._v(" " + _vm._s(_vm.year) + " " + _vm._s(_vm.month) + " ")]
          ),
          _c("div", { staticClass: "text-caption font-weight-black" }),
          _c(
            "div",
            {
              staticClass: "max-width d-flex mt-1 align-start pr-2 py-2 mx-n2",
            },
            [
              _c("v-autocomplete", {
                ref: "filterStaff2",
                staticClass: "py-2 spacial-v-autocomplete",
                attrs: {
                  items: _vm.allStaff,
                  filled: "",
                  rounded: "",
                  height: "40",
                  dense: "",
                  "allow-overflow": false,
                  "hide-details": "",
                  "append-icon":
                    _vm.filterStaffs.length > 0 && !_vm.isFocus
                      ? "search"
                      : "arrow_drop_down",
                  "single-line": "",
                  placeholder:
                    _vm.$t("label_essweb_leaveBalance_list_staffNameLabel") +
                    "/" +
                    _vm.$t("label_essweb_leaveBalance_list_staffIdLabel"),
                  chips: "",
                  readonly: _vm.isReadOnly,
                  "open-on-clear": false,
                  multiple: "",
                  filter: _vm.$staffFilter,
                  "item-text": "staff_code",
                  "item-value": "staff_id",
                },
                on: {
                  focus: function ($event) {
                    _vm.isFocus = true
                  },
                  blur: _vm.toFocus,
                  "click:append": function ($event) {
                    _vm.filterStaffs.length > 0 && !_vm.isFocus
                      ? _vm.toSearch()
                      : null
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "no-data",
                      fn: function () {
                        return [_c("noContent")]
                      },
                      proxy: true,
                    },
                    _vm.allStaff.length > 0
                      ? {
                          key: "prepend-item",
                          fn: function () {
                            return [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-4",
                                  attrs: { dense: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.$nextTick(function () {
                                        if (
                                          _vm.filterStaffs.length ===
                                          _vm.allStaff.length
                                        ) {
                                          _vm.filterStaffs = []
                                          _vm.$refs.filterStaff2.blur()
                                          _vm.$emit("search", null)
                                        } else {
                                          _vm.$refs.filterStaff2.blur()
                                          _vm.filterStaffs = []
                                          _vm.allStaff.map(function (item) {
                                            _vm.filterStaffs.push(item.staff_id)
                                          })
                                        }
                                      })
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-action",
                                    { staticClass: "mx-0 my-0 mr-1" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "material-icons-round",
                                          class:
                                            _vm.filterStaffs.length !== 0 &&
                                            _vm.filterStaffs.length ===
                                              _vm.allStaff.length
                                              ? "primary--text"
                                              : _vm.filterStaffs.length > 0 &&
                                                _vm.filterStaffs.length !==
                                                  _vm.allStaff.length
                                              ? "primary--text"
                                              : "text--secondary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.filterStaffs.length !== 0 &&
                                                  _vm.filterStaffs.length ===
                                                    _vm.allStaff.length
                                                  ? "check_box"
                                                  : _vm.filterStaffs.length >
                                                      0 &&
                                                    _vm.filterStaffs.length !==
                                                      _vm.allStaff.length
                                                  ? "indeterminate_check_box"
                                                  : "check_box_outline_blank"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_system_select_selectAllLabel"
                                              )
                                            )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-divider"),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                    {
                      key: "selection",
                      fn: function (data) {
                        return [
                          data.index < 1
                            ? _c(
                                "v-chip",
                                _vm._b(
                                  {
                                    staticClass: "mx-0 mr-1 pr-2",
                                    attrs: { close: "", pill: "" },
                                    on: {
                                      "click:close": function ($event) {
                                        return _vm.removeStaff(data.item)
                                      },
                                    },
                                  },
                                  "v-chip",
                                  data.attrs,
                                  false
                                ),
                                [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      left: "",
                                      src: data.item.staff_avatar,
                                      staff_name: data.item.preferred_name,
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-inline-block text-truncate",
                                      staticStyle: { "max-width": "60px" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              data.item.preferred_name
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          data.index === 1
                            ? _c(
                                "span",
                                { staticClass: "text--primary py-2" },
                                [
                                  _vm._v(
                                    " ... " +
                                      _vm._s(_vm.filterStaffs.length - 1) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item",
                      fn: function (data) {
                        return [
                          _c(
                            "v-list",
                            { attrs: { rounded: "", width: "100%", nav: "" } },
                            [
                              _c(
                                "v-list-item",
                                {
                                  attrs: {
                                    rouned: "",
                                    width: "100%",
                                    nav: "",
                                    "two-line": "",
                                    dense: "",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    {
                                      staticClass: "ma-0 mr-1 white--text",
                                      attrs: { size: "36" },
                                    },
                                    [
                                      _c("StaffAvatar", {
                                        attrs: {
                                          size: "36",
                                          src: data.item.staff_avatar,
                                          staff_name: data.item.preferred_name,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "text-body-2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                data.item.preferred_name
                                              )
                                            ) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text--secondary text-caption-xs",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(data.item.staff_code)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              data.item.job_post_name
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.filterStaffs,
                  callback: function ($$v) {
                    _vm.filterStaffs = $$v
                  },
                  expression: "filterStaffs",
                },
              }),
            ],
            1
          ),
          0
            ? _c(
                "div",
                { staticClass: "max-width d-flex mt-1 align-start" },
                [
                  _vm.isEdited
                    ? _c("v-checkbox", {
                        staticClass: "mt-0 pt-0 ml-n1",
                        staticStyle: { pointer: "cursor" },
                        attrs: {
                          ripple: false,
                          color: _vm.isHalf ? "grey" : "",
                          readonly: false,
                          "hide-details": "",
                          indeterminate: _vm.isHalf,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text--secondary text-caption",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_RosterFormRecord_form_table_staffNameLabbel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2722790836
                        ),
                        model: {
                          value: _vm.checked,
                          callback: function ($$v) {
                            _vm.checked = $$v
                          },
                          expression: "checked",
                        },
                      })
                    : _c(
                        "span",
                        { staticClass: "text--secondary text-caption py-1" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_RosterFormRecord_form_table_staffNameLabbel"
                              )
                            )
                          ),
                        ]
                      ),
                  _c("v-spacer"),
                  0
                    ? _c("v-btn", { attrs: { icon: "" } }, [
                        _c("span", { staticClass: "material-icons-round" }, [
                          _vm._v("more_vert"),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }